var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"earthquake-report-view"},[_c('EarthquakeReportComponent')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }